import { render, staticRenderFns } from "./view-aisle.vue?vue&type=template&id=4daeb748&"
import script from "./view-aisle.vue?vue&type=script&lang=ts&"
export * from "./view-aisle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports